import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=97ab3a78&"
import script from "./DataTableRow.vue?vue&type=script&lang=js&"
export * from "./DataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DataTableRow.vue"
export default component.exports